import { Inbox } from 'lucide-react';

import { defineTour } from '@nucleus-commerce/admin-kit/tour';

import { MANAGE } from './manage';
import { applicationForReview } from './resolvers';

export const platformApplicationsListTour = defineTour({
  id: 'platform.applications.list',
  version: 1,
  group: 'applications',
  route: '/_authed/applications/',
  scope: 'org',
  icon: Inbox,
  steps: [
    { id: 'intro', kind: 'intro' },
    { id: 'tabs', kind: 'action', target: 'platform.applications.tabs' },
    { id: 'search', kind: 'explain', target: 'platform.applications.search' },
    { id: 'table', kind: 'explain', target: 'platform.applications.table', placement: 'top' },
  ],
  related: ['platform.applications.detail'],
});

export const platformApplicationDetailTour = defineTour({
  id: 'platform.applications.detail',
  version: 1,
  group: 'applications',
  route: '/_authed/applications/$applicationId',
  scope: 'record',
  resolve: applicationForReview,
  icon: Inbox,
  steps: [
    { id: 'brand', kind: 'explain', target: 'platform.applications.brand' },
    { id: 'owner', kind: 'explain', target: 'platform.applications.owner', placement: 'left' },
    { id: 'notes', kind: 'explain', target: 'platform.applications.notes', placement: 'top' },
    {
      id: 'mark-contacted',
      kind: 'explain',
      target: 'platform.applications.mark-contacted',
      requires: MANAGE,
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'approve',
      kind: 'explain',
      target: 'platform.applications.approve',
      requires: MANAGE,
      optional: true,
      waitMs: 1000,
    },
    {
      id: 'reject',
      kind: 'explain',
      target: 'platform.applications.reject',
      requires: MANAGE,
      optional: true,
      waitMs: 1000,
    },
  ],
  related: ['platform.organizations.detail'],
});
